import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Bell, BellFill, CheckCircle, XCircle, InfoCircle, ExclamationCircle, Megaphone } from "react-bootstrap-icons";
import OutsideClickHandler from "react-outside-click-handler";
import useT from "../../i18n/useT";
import core from "../../core";

const typeIcon = (type) => {
    if (type === "success") return <CheckCircle style={{ color: "#34c38f" }} />;
    if (type === "warning") return <ExclamationCircle style={{ color: "#ff9f0a" }} />;
    if (type === "broadcast") return <Megaphone style={{ color: "#2f80ed" }} />;
    if (type === "error") return <XCircle style={{ color: "#dc3545" }} />;
    return <InfoCircle style={{ color: "#2f80ed" }} />;
};

const NotificationBell = () => {
    const t = useT();
    const [open, setOpen] = useState(false);
    const [items, setItems] = useState([]);
    const [unread, setUnread] = useState(0);
    const pollRef = useRef(null);

    const loadCount = () => {
        axios.get("/api/notifications/unread-count").then((res) => setUnread(res.data.unread || 0)).catch(() => {});
    };
    const loadList = () => {
        axios.get("/api/notifications?limit=20").then((res) => { setItems(res.data.data || []); setUnread(res.data.unread || 0); }).catch(() => {});
    };

    useEffect(() => {
        loadCount();
        pollRef.current = setInterval(loadCount, 45000);
        return () => clearInterval(pollRef.current);
    }, []);

    const toggle = () => {
        const next = !open;
        setOpen(next);
        if (next) loadList();
    };

    const onItem = (n) => {
        if (!n.is_read) {
            axios.put(`/api/notifications/${n.id}/read`).then(() => { setUnread((u) => Math.max(0, u - 1)); }).catch(() => {});
        }
        if (n.link) window.location.assign(n.link);
        else setItems((prev) => prev.map((x) => (x.id === n.id ? { ...x, is_read: 1 } : x)));
    };

    const markAll = () => {
        axios.put("/api/notifications/read-all").then(() => {
            setUnread(0);
            setItems((prev) => prev.map((x) => ({ ...x, is_read: 1 })));
        }).catch(() => {});
    };

    return (
        <div className="notif-bell" style={{ position: "relative", display: "flex", alignItems: "center" }}>
            <button onClick={toggle} title={t("notif.title")} style={{ background: "none", border: "none", cursor: "pointer", color: "inherit", position: "relative", display: "flex", alignItems: "center", padding: "0 8px" }}>
                {unread > 0 ? <BellFill style={{ fontSize: "20px" }} /> : <Bell style={{ fontSize: "20px" }} />}
                {unread > 0 && (
                    <span style={{ position: "absolute", top: "-6px", right: "0", background: "#dc3545", color: "#fff", fontSize: "10px", fontWeight: 700, minWidth: "16px", height: "16px", lineHeight: "16px", borderRadius: "8px", textAlign: "center", padding: "0 3px" }}>
                        {unread > 99 ? "99+" : unread}
                    </span>
                )}
            </button>
            {open && (
                <OutsideClickHandler onOutsideClick={() => setOpen(false)}>
                    <div style={{ position: "absolute", top: "32px", right: 0, width: "340px", maxWidth: "88vw", background: "var(--card)", border: "1px solid var(--border)", borderRadius: "12px", boxShadow: "0 10px 30px rgba(0,0,0,0.2)", zIndex: 1000, overflow: "hidden" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 14px", borderBottom: "1px solid var(--border)" }}>
                            <strong style={{ fontSize: "14px" }}>{t("notif.title")}</strong>
                            {unread > 0 && <span onClick={markAll} style={{ fontSize: "12px", color: "#2f80ed", cursor: "pointer" }}>{t("notif.markAllRead")}</span>}
                        </div>
                        <div style={{ maxHeight: "380px", overflowY: "auto" }}>
                            {items.length === 0 ? (
                                <div style={{ padding: "24px 14px", textAlign: "center", opacity: 0.6, fontSize: "13px" }}>{t("notif.none")}</div>
                            ) : items.map((n) => (
                                <div key={n.id} onClick={() => onItem(n)} style={{ display: "flex", gap: "10px", padding: "11px 14px", borderBottom: "1px solid var(--border)", cursor: "pointer", background: n.is_read ? "transparent" : "rgba(47,128,237,0.07)" }}>
                                    <div style={{ flex: "0 0 auto", fontSize: "18px", marginTop: "1px" }}>{typeIcon(n.type)}</div>
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <div style={{ fontSize: "13px", fontWeight: n.is_read ? 500 : 700 }}>{n.title}</div>
                                        {n.body && <div style={{ fontSize: "12px", opacity: 0.75, marginTop: "2px" }}>{n.body}</div>}
                                        <div style={{ fontSize: "11px", opacity: 0.5, marginTop: "3px" }}>{n.created_at ? core.formdatDate(n.created_at, "dd-mm-yyyy") : ""}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </OutsideClickHandler>
            )}
        </div>
    );
};

export default NotificationBell;
